import { MouseEvent } from "react";
import { TableRow, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  FieldArrayWithId,
  UseFieldArrayUpdate,
  useFormContext,
} from "react-hook-form";

import { StyledTableCell } from "../Unions/unionsStyles";
import { TextFieldLight } from "../../../common/components/styled/styled";
import { PricingFormValues } from "./SupplementPricing";
import { ReactComponent as CheckmarkIcon } from "../../../common/icons/checkGreen.svg";
import { ReactComponent as CrossRedIcon } from "../../../common/icons/crossRed.svg";

type Props = {
  field: FieldArrayWithId<PricingFormValues, "prices", "id">;
  index: number;
  update: UseFieldArrayUpdate<PricingFormValues, "prices">;
};

export const PricingRow = ({ field, index, update }: Props) => {
  const { t } = useTranslation();

  const { register } = useFormContext();

  return (
    <TableRow>
      <StyledTableCell>
        <TextFieldLight
          disabled
          {...register(`prices.${index}.name`)}
          size="small"
        />
      </StyledTableCell>
      <StyledTableCell>
        <TextFieldLight
          defaultValue={`${field.unitValue}`}
          {...register(`prices.${index}.unitValue`)}
          size="small"
        />
      </StyledTableCell>
      <StyledTableCell>
        <TextFieldLight
          disabled
          value={t(`settings:${field.unit}`)}
          {...register(`prices.${index}.unit`)}
          size="small"
        />
      </StyledTableCell>
      <StyledTableCell>
        <ToggleButtonGroup
          exclusive
          {...register(`prices.${index}.unitValueOverrideAllowed`)}
          value={field.unitValueOverrideAllowed}
          onChange={(event: MouseEvent<HTMLElement>, value: boolean) => {
            if (value === null) return;
            update(index, { ...field, unitValueOverrideAllowed: value });
          }}
        >
          <ToggleButton value={true}>
            <CheckmarkIcon />
          </ToggleButton>
          <ToggleButton value={false}>
            <CrossRedIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </StyledTableCell>
    </TableRow>
  );
};
